import { useCartContext } from '@/context/cart';
import { calculateShippingDate } from '@/util/calculate-shipping-date';
import { gql, useQuery } from '@apollo/client';
import { ReactNode } from 'react';

interface Props {
  renderContent: (estDeliveryText: string | null) => ReactNode;
}

const StandardShippingDate = (props: Props) => {
  const { renderContent } = props;
  const [{ cartId }] = useCartContext();

  const { data } = useQuery(
    gql(/* GraphQL */ `
      query getAvailableShippingMethods($cartId: String!) {
        cart(cart_id: $cartId) {
          id
          shipping_addresses {
            street
            available_shipping_methods {
              delivery_time_from
              delivery_time_to
              shipping_type
              carrier_code
              method_code
            }
          }
        }
      }
    `),
    {
      skip: !cartId,
      variables: {
        cartId,
      },
    },
  );

  const standardShippingMethod = data?.cart?.shipping_addresses?.[0]?.available_shipping_methods?.find(
    x => x?.shipping_type === 2,
  );

  if (typeof renderContent !== 'function') return null;

  const estDeliveryText = calculateShippingDate(
    standardShippingMethod ? standardShippingMethod.delivery_time_from : 4,
    standardShippingMethod ? standardShippingMethod.delivery_time_to : 6,
  );

  return renderContent(estDeliveryText);
};

export default StandardShippingDate;
